import React, { Component } from "react";
import FlexView from "react-flexview";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDate from "../../../modules/SimpleDate";
import SimpleDDL from "../../../modules/SimpleDDL";
import Api from "../../../Services/Api";
import PenerimaanSSUTable from "./penerimaanSSU/penerimaanSSUTable";
import PengajuanSSUTable from "./pengajuanSSU/pengajuanSSUTable";
import { mapToObjectDDL } from "../../common/mapper";
import M from "moment";
import * as R from "ramda";
import { connect } from "react-redux";
import { HttpStatus } from "../../common/Constants";
import ErrorAction from "../../../Redux/ErrorRedux";
import { fetchDataAsync } from "../../../Services/Utils";

class ProsesSSU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFilter: false,
      loading: false,
      activeIndex: 0,
      submittedFilterData: {},
      fromTime: new Date(),
      toTime: new Date(),
      pagination: {
        totalData: 1,
        limit: 5,
        page: 1,
      },
      cabangOptions: [],
      search: { kodeCabang: null },
      dataTable: [],
      warnaOptions: [],
      variantOptions: [],
      warnaRaw: [],
      fromFetchData: false,
    };
  }

  async componentDidMount() {
    this.triggerLoading();
    await this.fetchDataCabang();
    const responses = await Promise.all([
      Api.create("NAGAMAS_MASTER_DATA").getAllWarna(),
      Api.create("NAGAMAS_MASTER_DATA").getAllVariant(),
    ]);

    if (responses[0].ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        warnaOptions: responses[0].data.data.map((w) =>
          mapToObjectDDL(w.namaWarnaKomersil, w.id)
        ),
        warnaRaw: responses[0].data.data,
      }));
    }

    if (responses[1].ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        variantOptions: [
          { label: "ALL", value: "ALL" },
          ...responses[1].data.data.map((kv) =>
            mapToObjectDDL(kv.namaVariant, kv.kodeVariant)
          ),
        ],
      }));
    }
    this.triggerLoading();
  }

  async componentDidUpdate(_, prevState) {
    if (prevState.activeIndex !== this.state.activeIndex) {
      // this.handleRefreshPagination();
      // this.setState({fromFetchData: true});
      this.handleRefresh();
    }
    if (prevState.search.kodeCabang !== this.state.search.kodeCabang) {
      this.handleRefreshPagination();
      this.setState({ fromFetchData: true });
      this.handleRefresh();
    }
    if (
      (prevState.pagination.page !== this.state.pagination.page ||
        prevState.pagination.limit !== this.state.pagination.limit) &&
      !this.state.fromFetchData
    ) {
      this.triggerLoading();
      await this.fetchData(
        this.state.submittedFilterData,
        this.state.pagination.page,
        this.state.pagination.limit,
        this.state.isFilter
      );
      this.triggerLoading();
    }
    if (this.state.fromFetchData) {
      this.setState({ fromFetchData: false });
    }
  }

  handleRefreshPagination = () => {
    this.setState((prevState) => ({
      ...prevState,
      pagination: {
        totalData: 1,
        limit: 5,
        page: 1,
      },
    }));
  };

  handleRefresh = async () => {
    this.triggerLoading();
    this.setState((prevValue) => ({
      ...prevValue,
      fromTime: new Date(),
      toTime: new Date(),
    }));
    const request = {
      kodeCabang: this.state.search.kodeCabang.value,
      fromTime: M().format("DD-MM-yyyy"),
      toTime: M().format("DD-MM-yyyy"),
    };

    await this.fetchData(request);
    this.triggerLoading();
  };

  handleSubmitSSU = async (data) => {
    this.triggerLoading();
    const { __pagination, ...cleanData } = data;

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").createSSU,
      menuName: "Proses SSU",
      setError: this.props.setError,
      args: cleanData,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      await this.refetch(__pagination);
    }

    this.triggerLoading();
  };


  refetch = async () => {
    this.triggerLoading();
    const { page, limit } = this.state.pagination;

    const request = {
      ...this.state.submittedFilterData,
      kodeCabang: this.state.search.kodeCabang.value,
      fromTime: this.state.fromTime
        ? M(this.state.fromTime).format("DD-MM-yyyy")
        : null,
      toTime: this.state.toTime
        ? M(this.state.toTime).format("DD-MM-yyyy")
        : null,
    };

    await this.fetchData(
      request,
      page,   
      limit, 
      this.state.isFilter
    );

    this.triggerLoading();
  };


  fetchDataCabang = async () => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
      if (res.ok) {
        let filteredData = res.data.data.filter((item) =>
          this.props.menuAccess
            .map((data) => data.idRefObj)
            .includes(item.kodeCabang)
        );

        if (filteredData.length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            cabangOptions: filteredData,
            search: {
              ...prevValue.search,
              kodeCabang: mapToObjectDDL(
                filteredData[0].namaDealer,
                filteredData[0].kodeCabang
              ),
            },
          }));
        }
      }
    } catch (error) {
      console.log("errors", error);
    }
  };

  fetchData = async (filter = {}, page = 1, limit = 5, isFilter = false) => {
    this.setState((prevValue) => ({ ...prevValue, fromFetchData: true }));
    let response;
    if (!R.isEmpty(filter)) {
      if (this.state.activeIndex === 0) {
        response = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").getSubmissionSSU,
          menuName: "Proses SSU - Pengajuan SSU",
          setError: this.props.setError,
          args: {
            ...filter,
            limit,
            page,
            kodeCabang: this.state.search.kodeCabang?.value,
          },
        });
      } else if (!isFilter) {
        response = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").getReceivedSSUByPeriod,
          menuName: "Proses SSU - Pengajuan SSU",
          setError: this.props.setError,
          args: {
            ...filter,
            limit,
            page,
            kodeCabang: this.state.search.kodeCabang?.value,
          },
        });
      } else {
        response = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").getReceivedSSU,
          menuName: "Proses SSU - Pengajuan SSU",
          setError: this.props.setError,
          args: {
            ...filter,
            limit,
            page,
            kodeCabang: this.state.search.kodeCabang?.value,
          },
        });
      }
    }

    if (response?.ok && response?.data?.status === HttpStatus.SUCCESS) {
      const data = response.data.data;
      await this.setState((prevValue) => ({
        ...prevValue,
        submittedFilterData: filter,
        pagination: {
          ...prevValue.pagination,
          page: page,
          limit: limit,
          totalData: response.data.totalData,
        },
        dataTable: !R.isEmpty(data)
          ? data.map((ssu) => {
              const variantValue = this.state.variantOptions.find((kv) =>
                R.equals(kv.value, ssu.variant.kodeVariant)
              );
              const warnaValue = this.state.warnaRaw.find((w) =>
                R.equals(w.id, ssu.warna.kodeWarna)
              );
              return {
                ...ssu,
                variant: {
                  ...ssu.variant,
                  namaVariant: variantValue ? variantValue.label : null,
                },
                warna: {
                  ...warnaValue ? warnaValue : ssu.warna,
                },
              };
            })
          : [],
      }));
    }
    this.setState((prevValue) => ({ ...prevValue, fromFetchData: false }));
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
        totalData: 0,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 0,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleSubmitFilter = async (request) => {
    if (!R.isEmpty(request)) {
      this.setState((prevValue) => ({
        ...prevValue,
        loading: true,
        fromTime: null,
        toTime: null,
        isFilter: true,
      }));
      this.handleRefreshPagination();
      this.setState({ skipNextPaginationFetch: true });
      await this.fetchData(
        {
          ...request,
          kodeCabang: this.state.search.kodeCabang.value,
        },
        1,
        5,
        true
      );
      this.setState((prevValue) => ({
        ...prevValue,
        loading: false,
        submittedFilterData: request,
      }));
    } else {
      await this.setState((prevValue) => ({
        ...prevValue,
        loading: true,
        fromTime: new Date(),
        toTime: new Date(),
        isFilter: false,
      }));
      this.handleRefreshPagination();
      this.setState({ skipNextPaginationFetch: true });
      request = {
        kodeCabang: this.state.search.kodeCabang.value,
        fromTime: M(this.state.fromTime).format("DD-MM-yyyy"),
        toTime: M(this.state.toTime).format("DD-MM-yyyy"),
      };
      await this.fetchData(request);
      this.setState((prevValue) => ({
        ...prevValue,
        loading: false,
        submittedFilterData: request,
      }));
    }
  };

  handleChangeTab = (index) => {
    this.setState((prevValue) => ({
      ...prevValue,
      activeIndex: index,
      fromTime: new Date(),
      toTime: new Date(),
      pagination: {
        totalData: 1,
        limit: 5,
        page: 1,
      },
      submittedFilterData: {},
      isFilter: false,
    }));
  };

  triggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleCabangChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: value,
      },
    }));
  };

  handleChangeDate = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSubmitPeriod = async () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
      isFilter: false,
    }));
    const request = {
      kodeCabang: this.state.search.kodeCabang.value,
      fromTime: M(this.state.fromTime).format("DD-MM-yyyy"),
      toTime: M(this.state.toTime).format("DD-MM-yyyy"),
    };
    this.setState((prevValue) => ({
      ...prevValue,
      submittedFilterData: request,
    }));
    await this.fetchData(request, 1, 5);
    this.triggerLoading();
  };

  render() {
    return (
      <>
        <Container>
          <SimpleDDL
            id="select_options_nama_cabang"
            box="search"
            name="kodeCabang"
            containerclassname="width width-250px"
            placeholder="Nama cabang hak akses"
            options={this.state.cabangOptions.map((item) =>
              mapToObjectDDL(item.namaDealer, item.kodeCabang)
            )}
            value={this.state.search.kodeCabang}
            onChange={(value, { name }) => this.handleCabangChange(name, value)}
          />
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <p className="margin-bottom-20px">Periode</p>
            <SimpleDate
              id="select_date_startDate"
              name="fromTime"
              nextdate
              date={this.state.fromTime}
              maxDate={new Date()}
              onChange={(value) => this.handleChangeDate("fromTime", value)}
            />
            <SimpleDate
              id="select_date_endDate"
              name="endDate"
              nextdate
              date={this.state.toTime}
              maxDate={new Date()}
              onChange={(value) => this.handleChangeDate("toTime", value)}
            />
            <SimpleButton
              type="submit"
              className="margin-bottom-20px"
              onClick={this.handleSubmitPeriod}
            >
              Cari
            </SimpleButton>
          </FlexView>
          <Tabs
            selectedIndex={this.state.activeIndex}
            onSelect={this.handleChangeTab}
          >
            <TabList>
              <Tab>Pengajuan SSU</Tab>
              <Tab>Penerimaan SSU</Tab>
            </TabList>
            <TabPanel>
              <PengajuanSSUTable
                state={this.state}
                triggerLoading={this.triggerLoading}
                user={this.props.user.user}
                onSubmitSSU={this.handleSubmitSSU}
                onSubmitFilter={this.handleSubmitFilter}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleRowsPerPage}
              />
            </TabPanel>
            <TabPanel>
              <PenerimaanSSUTable
                state={this.state}
                triggerLoading={this.triggerLoading}
                user={this.props.user.user}
                onSubmitSSU={this.handleSubmitSSU}
                onSubmitFilter={this.handleSubmitFilter}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleRowsPerPage}
              />
            </TabPanel>
          </Tabs>
        </Container>
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProsesSSU);
